import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Absolute from '@rsos/components/capstone/base/Absolute';
import getInitials from '@rsos/utils/getInitials';
import { Container, Avatar, ActiveIndicator } from './ChatAvatar.styles';

/**
 * display an avatar circle using the agency's initials, if the initials contain more than two
 * letters, then display only the first letter.
 *
 * @param {boolean} displayActiveIndicator - display the agency's active status
 * @param {boolean} isActive - is the agency active or not
 * @param {boolean} isOverlapped - used in the ChatHeader component to display overlapped avatars
 *   when there are multiple agencies involved in a chat
 * @param {string} name - agency display name
 *
 * @returns agency avatar circle
 */
const ChatAvatar = ({
  displayActiveIndicator,
  isActive,
  isOverlapped,
  name,
}) => {
  const [agencyInitials, setAgencyInitials] = useState('');

  useEffect(() => {
    if (name && agencyInitials !== name && agencyInitials !== name.charAt(0)) {
      const initials = getInitials(name, 'uppercase');

      if (initials.length > 2) {
        setAgencyInitials(initials.charAt(0));
      } else {
        setAgencyInitials(initials);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  return (
    agencyInitials && (
      <Container isOverlapped={isOverlapped}>
        {displayActiveIndicator ? (
          <>
            <Avatar displayActiveIndicator={displayActiveIndicator}>
              {agencyInitials}
            </Avatar>
            <Absolute top={-1} right={-3} zIndex={15}>
              <ActiveIndicator isActive={isActive} />
            </Absolute>
          </>
        ) : (
          <>
            <Avatar>{agencyInitials}</Avatar>
            {isOverlapped && (
              <Absolute top={-5} left={-5} zIndex={5}>
                <Avatar />
              </Absolute>
            )}
          </>
        )}
      </Container>
    )
  );
};

ChatAvatar.propTypes = {
  displayActiveIndicator: PropTypes.bool,
  isActive: PropTypes.bool,
  isOverlapped: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

export default ChatAvatar;
